// import { ImagePreview } from 'vant'
import axios from 'axios'
import {
  queryTimeList2,
  queryCourseData,
  queryArgsToId,
  queryIdToArgs,
  getCombinationCourseList,
  getCombinationPoster
} from '@/api'
import merge from 'webpack-merge'
import QRCode from 'qrcodejs2'
import html2canvas from 'html2canvas'
import { Dialog, Toast } from 'vant'

export default {
  name: 'detail-page',
  data () {
    return {
      timeList: [],
      ihubTimeList: [{
        name: '2026暑期（一期7月19日入营）',
        value: '2026-07-03'
      }, {
        name: '2026暑期（中山7月27日入营）',
        value: '2026-07-13'
      }],
      dialogCheckActivemonth: [],
      currentPage: 1,
      allPage: 1,
      list: [],
      dataList: [],
      loading: false,
      finished: false,
      tabList: [], // tab栏
      tabId: -1,
      topTabList: [],
      peopleList: [{
        name: '全部',
        value: ''
      },
      {
        name: '大学生',
        value: 1
      },
      {
        name: '高中生',
        value: 2
      }
      ],
      optionList: [{
        name: '中国科学院大学',
        value: '中国科学院大学',
        realValue: ['中国科学院大学']
      },
      {
        name: '深圳',
        value: '深圳',
        realValue: ['深圳', '深圳知名国际学校']
      }
      ],
      optionList1: [{
        name: '上海营地',
        value: '上海营地',
        realValue: ['上海']
      },
      {
        name: '深圳营地',
        value: '深圳营地',
        realValue: ['深圳']
      },
      {
        name: '中山大学营地',
        value: '中山大学营地',
        realValue: ['中山大学深圳校区']
      }
      ],
      activeOption: [],
      majorList: [{
        name: '全部',
        value: 9999
      }, {
        name: '金融商科',
        value: 1
      }, {
        name: '理工科',
        value: 2
      }, {
        name: '人文社科',
        value: 3
      }, {
        name: '计算机科学与人工智能',
        value: 4
      }],
      activePeople: {
        name: '全部',
        value: ''
      },
      combinationPoster: null,
      suggestCollege: false,
      suggestSenior: false,
      suggestAll: false,
      imgBig: '',
      imgBigShow: false,
      imgBigShow1: false,
      tabActive: null,
      valueName: null,
      level1: null,
      pageType: null,
      righCheckedList: [],
      combinationShow: false,
      checkedCombination: null,
      addCombinationShow: false,
      showDate: false,
      showTypePicker: false,
      showCourseListPicker: false,
      combination: {
        date: '',
        name: '',
        type: '',
        typeId: '',
        courseTypeId: '',
        courseName: '',
        courseId: '',
        dateList: []
      },
      coursename: '',
      courseTypeList: [{
        name: '全球华人导师',
        id: 6
      },
      {
        name: '全球华人导师-香港',
        id: 32
      },
      {
        name: '全球华人导师-海外',
        id: 44
      },
      {
        name: '国内导师线下项目',
        id: 39
      }
      ],
      courseList: [],
      currentItem: null,
      combinationDetail: null,
      imgsrc: null,
      imgsrc1: null,
      zuImg: null,
      zuloading: false,
      maxDate: new Date(),
      optionList2: [
        { name: '北京', value: '北京' },
        // 2023-05-18 一个关键词对应多个查询条件
        { name: '上海', value: '上海', realValue: ['上海知名国际学校', '上海交通大学·长宁校区', '复旦大学·生命科学创新实践基地'] },
        // { name: '深圳', value: '深圳', realValue: ['深圳知名国际学校'] },
        // { name: '长春', value: '长春', realValue: ['长春知名高校'] },
        { name: '广州', value: '广州', realValue: ['广州', '广州知名中学'] },
        { name: '青岛', value: '青岛' },
        { name: '杭州', value: '杭州' },
        { name: '南京', value: '南京' }
        // { name: '成都', value: '成都', realValue: ['四川大学·望江校区'] },
        // { name: '武汉', value: '武汉', realValue: ['武汉英中高级中学-古田校区'] },
        // { name: '广州', value: '广州' },
        // { name: '哥伦比亚大学', value: '哥伦比亚大学', realValue: ['哥伦比亚大学'] },
        // { name: '剑桥大学', value: '剑桥大学', realValue: ['剑桥大学'] },
        // { name: '牛津大学', value: '牛津大学', realValue: ['牛津大学'] }
      ],
      dialogCheckData6: null,
      dialogCheckData7: null,
      seachData: null,
      imageCache: new Map() // 缓存已加载的图片
    }
  },
  created () {
    this.level1 = Number(this.$route.query.level1)
    this.pageType = Number(this.$route.query.level1)
    this.seachData = this.$route.query.seach
    if (this.pageType === 5) { // aihub走全部接口
      this.level1 = 9999
      this.topTabList = ['专业方向', '适合人群', '开课时间', '营地地点']
    } else {
      if (this.pageType === 6) {
        this.level1 = 9999
        this.topTabList = ['专业方向', '适合人群', '开课时间', '海报类型']
      } else if (this.pageType === 7) {
        this.level1 = 9999
        this.topTabList = ['专业方向', '实验室地点']
      } else if (this.pageType === 8) { // 全球名研 不要搜索
        this.level1 = 9999
        this.topTabList = ['专业方向', '适合人群', '项目类别']
      } else if (this.pageType === 9) {
        this.level1 = 9999
        this.topTabList = ['专业方向', '适合人群', '开课时间']
      } else if (this.pageType === 44) {
        this.level1 = 9999
        this.topTabList = ['专业方向', '适合人群', '项目类别', '开课时间']
      } else {
        this.topTabList = ['专业方向', '适合人群', '项目类别', '开课时间'] // 默认【理工，人文， 金融， 计算机， 9999 ， 44】
      }
      // this.topTabList = ['专业方向', '适合人群', '开课时间']
    }
    this.setWXShareInfo()
    const nowDat = new Date()
    const dateY = nowDat.getFullYear()
    const dateM = nowDat.getMonth()
    const dateD = nowDat.getDate()
    this.maxDate = new Date(dateY + 1, dateM, dateD)
  },
  methods: {
    getLine (index) {
      this.$nextTick(() => {
        const noticeDom = this.$refs[index][0]
        const notice1 = noticeDom.parentNode.nextSibling.firstElementChild
        const style = window.getComputedStyle(noticeDom, null)
        const style1 = window.getComputedStyle(notice1, null)
        const row = Math.floor(
          Number(style.height.replace('px', '')) /
          Number(style.lineHeight.replace('px', ''))
        )
        const row1 = Math.floor(
          Number(style1.height.replace('px', '')) /
          Number(style1.lineHeight.replace('px', ''))
        )
        if (row >= 4) {
          noticeDom.style.cssText = 'line-clamp:4;-webkit-line-clamp:4'
          notice1.style.cssText = 'line-clamp:2;-webkit-line-clamp:2'
        }
        if (row1 >= 3) {
          notice1.style.cssText = 'line-clamp:3;-webkit-line-clamp:3'
        }
      })
    },
    // 获取时间借口 【计算机，理工，人文，金融 是初始化默认的 level1 】【其他类型是 手动切换专业方向传入的值】
    async getTimeList () {
      let idList = null
      const level1 = this.level1
      if (this.pageType === 5) { // aihub单独参数
        idList = [39]
      } else if (this.pageType === 6) { // 企业导师远程实训
        idList = [45]
      } else if (this.pageType === 7) { // 实验室RA计划
        idList = [4]
      } else if (this.pageType === 8) { // 1v1
        idList = [56]
      } else if (this.pageType === 44) { // 海外导师
        idList = [44]
      } else if (this.pageType === 9) { // 全球导师，海外，香港 ，【6， 32， 44】
        idList = [6, 32, 44]
      } else if (this.pageType === 9999 && !this.$route.query.seach) {
        idList = [32]
      } else {
        if (this.$route.query.seach) {
          // 专业选修课49是 国外h5单独页面
          idList = [6, 32, 44, 39, 45, 4, 56]
        } else {
          idList = [6, 32, 44]
        }
      }
      const timeList = await queryTimeList2({
        level1: level1,
        typeIdList: idList
      })
      this.timeList = timeList.data
    },
    checkedPeople (item) {
      this.activePeople = item
    },
    checkedCombinationPoster (item) {
      this.combinationPoster = item
    },
    checkedOption (item) {
      // this.activeOption = item.value
      const index = this.activeOption.findIndex(item1 => item1 === item.value)
      if (index > -1) {
        this.activeOption.splice(index, 1)
      } else {
        this.activeOption.push(item.value)
      }
    },
    closeOverlay () {
      this.tabActive = null
    },
    inputQuerySure () {
      clearTimeout(this.timeSetout)
      this.timeSetout = setTimeout(() => {
        this.querySure()
      }, 800)
    },
    async querySure () {
      this.loading = true
      this.finished = false
      this.dataList = []
      this.currentPage = 1
      this.tabActive = null
      this.getAllDataOnSearch(1)
    },
    clicktab (item) {
      // aihub单独做处理
      this.tabActive = item
      // if (this.pageType === 5 && type === 2) {
      //   this.tabActive = 3
      // } else {
      //   this.tabActive = type
      // }
    },
    clickDialog6 (item) {
      this.dialogCheckData6 = item.name
    },
    clickDialog7 (item) {
      this.dialogCheckData7 = item
    },
    async getArgs (type) {
      if (this.$route.query.csName) {
        this.valueName = this.$route.query.csName
        this.$route.query.csName = null
      }
      let idList = null
      if (this.pageType === 5) { // aihub 单独进入
        idList = [39]
      } else if (this.pageType === 6) { // 企业导师远程实训
        idList = [45]
      } else if (this.pageType === 7) { // 实验室RA计划
        idList = [4]
      } else if (this.pageType === 8) { // 全球在研
        idList = [56]
      } else if (this.pageType === 44) { // 全球海外导师
        // this.level1 = 9999
        idList = [44]
      } else if (this.pageType === 9) { // 全球导师，海外，香港 ，【6， 32， 44】
        // this.level1 = 9999
        idList = [6, 32, 44]
      } else if (this.pageType === 9999 && !this.seachData) {
        idList = [32]
      } else {
        if (this.seachData) {
          idList = [6, 32, 44, 39, 45, 4, 56]
        } else {
          idList = [6, 32, 44]
        }
      }
      const realP = []
      this.activeOption.forEach(item => {
        const obj = this.optionList.find(item1 => item1.value === item)
        const obj1 = this.optionList1.find(item1 => item1.value === item)
        if (obj) {
          realP.push(...obj.realValue)
          if (obj1 && obj.value && obj1.value) {
            return
          }
        }
        if (obj1) {
          realP.push(...obj1.realValue)
        }
      })
      // 请求所有参数要记录下来，分享获取参数
      const args = {
        csName: this.valueName,
        suggestAll: !this.activePeople.value,
        suggestSenior: !!(this.activePeople.value && (this.activePeople.value === 2)),
        suggestCollege: !!(this.activePeople.value && (this.activePeople.value === 1)),
        page: this.currentPage,
        limit: 20,
        level1: this.level1,
        isH5: true,
        isCnPage: true,
        timeArr: this.pageType === 5 ? [] : this.dialogCheckActivemonth,
        position: this.pageType === 7 ? this.dialogCheckData6 : realP,
        level2: this.tabId,
        typeIdList: idList,
        isCombinationPoster: this.combinationPoster ? (this.combinationPoster === '科研+职业通途组合') : null,
        summerTimeArr: this.pageType === 5 ? this.dialogCheckActivemonth : [],
        pageType: this.pageType,
        seachData: this.seachData,
        types: this.pageType === 9 ? '研助起航系列' : this.dialogCheckData7
      }
      if (this.pageType === 7) {
        args.types = '名校实验室RA计划'
      }
      // 如果没有ID去换取ID 如果是搜索时候要重新获取id
      if (!this.$route.query.id || type === 1 || this.currentPage !== 1) {
        args.page = 1 // 传入后台1
        const result = await queryArgsToId({
          args: args
        })
        this.$router.replace({
          query: merge(this.$route.query, {
            id: result.data.id
          })
        })
        args.page = this.currentPage
        return args
      } else if (this.$route.query.id) {
        const result = await queryIdToArgs({
          id: this.$route.query.id
        })
        // 第一次记录的参数
        if (result && result.data && result.data.args) {
          this.initData(result.data.args)
          return result.data.args
        } else {
          return args
        }
      }
    },
    async initData (myargsObj) {
      // 如果是从连接跳转过来的有搜索默认数据
      if (myargsObj.csName) {
        this.valueName = myargsObj.csName
      }
      if (myargsObj.suggestAll) {
        this.suggestAll = this.peopleList[0]
      }
      if (myargsObj.suggestSenior) {
        this.activePeople = this.peopleList[2]
      }
      if (myargsObj.suggestCollege) {
        this.activePeople = this.peopleList[1]
      }
      if (myargsObj.page) {
        this.currentPage = myargsObj.page
      }
      if (myargsObj.level1) {
        this.level1 = myargsObj.level1
      }
      if (myargsObj.timeArr && myargsObj.timeArr.length) {
        this.dialogCheckActivemonth = myargsObj.timeArr
      } else {
        if (myargsObj.summerTimeArr && myargsObj.summerTimeArr.length) {
          this.dialogCheckActivemonth = myargsObj.summerTimeArr
        }
      }
      if (myargsObj.level2) {
        this.tabId = myargsObj.level2
      }
      if (myargsObj.position) {
        if (Array.isArray(myargsObj.position)) { // 多选地址
          this.activeOption = myargsObj.position
        } else {
          this.dialogCheckData6 = myargsObj.position // 单选 ‘字符串’
        }
      }
      if (myargsObj.isCombinationPoster) {
        this.combinationPoster = myargsObj.isCombinationPoster ? '科研+职业通途组合' : '单职业通途'
      }
      if (myargsObj.pageType) {
        this.pageType = myargsObj.pageType
      }
      if (myargsObj.seachData) {
        this.seachData = myargsObj.seachData
      }
      if (myargsObj.types) {
        this.dialogCheckData7 = myargsObj.types
      }
    },
    async getAllDataOnSearch (type) {
      const args = await this.getArgs(type)
      await this.getAllData(args)
    },
    async getAllDataOnFinish () {
      const args = await this.getArgs()
      await this.getAllData(args)
      this.getTimeList()
    },
    async getAllData (args) {
      clearTimeout(this.timeSetout)
      this.timeSetout = setTimeout(async () => {
        this.finished = false
        const list = await queryCourseData(args)
        // 20220929 接口的level = 9999 代表全部，但由于之前用的4，而且有的链接已经发出去了，故在这里搞了个修饰器
        if (list.data.level2) {
          this.tabList = list.data.level2
        } else {
          this.tabList = [{
            id: -1,
            name: '全部'
          }]
        }
        if (list.data.page === 1) {
          this.dataList = list.data ? list.data.levels : []
        } else {
          this.dataList = [...this.dataList, ...list.data.levels]
        }
        if (list.data.levels.length === 0) {
          this.loading = false
          this.currentPage = 1
          this.finished = true
          return
        }
        this.allPage = list.data.allPage
        this.currentPage += 1
        this.loading = false
      }, 600)
    },
    godetail (item) {
      const origin = window.location.origin
      if (process.env.NODE_ENV === 'development') {
        window.open('https://sou-m-testserver.gecacademy.cn/share?id=' + item.id)
      } else {
        if (origin.indexOf('-testserver') > -1) {
          window.open('https://sou-m-testserver.gecacademy.cn/share?id=' + item.id)
        } else {
          window.open('https://sou-m.gecacademy.cn/share?id=' + item.id)
        }
      }
    },
    rightClick (item) {
      const index = this.righCheckedList.findIndex(item1 => item1.id === item.id)
      if (index > -1) {
        this.righCheckedList = this.righCheckedList.filter(item1 => {
          return item1.id !== item.id
        })
      } else {
        this.righCheckedList.push({
          id: item.id,
          img: item.imageHeader,
          name: item.name
        })
      }
    },
    async resetDialog (type) {
      if (type === 1) {
        this.tabId = -1
        const list = [5, 6, 7, 8, 44, 9] // 全球华人导师 暑期 职业通途，实验室RA项目 全球在研 重置时默认9999全部项目
        this.level1 = list.findIndex(item => item === Number(this.$route.query.level1)) > -1 ? 9999 : Number(this.$route.query.level1)
      } else if (type === 2) {
        this.activePeople = {
          name: '全部',
          value: ''
        }
        this.suggestAll = true
        this.suggestCollege = false
        this.suggestSenior = false
      } else if (type === 3) {
        this.dialogCheckActivemonth = []
      } else if (type === 4) {
        this.activeOption = []
      } else if (type === 5) {
        this.combinationPoster = null
      } else if (type === 6) {
        this.dialogCheckData6 = null
      } else if (type === 7) {
        this.dialogCheckData7 = null
      }
      this.tabActive = null
      this.dataList = []
      await this.querySure()
    },
    // 切换tab
    async changeTab (item) {
      this.tabId = item.id
    },
    // 点击时间
    async clickDialogTime (item1, item) {
      const typeitem = item.year + '-' + item1
      const index = this.dialogCheckActivemonth.findIndex(item1 => item1 === typeitem)
      if (index > -1) {
        this.dialogCheckActivemonth.splice(index, 1)
      } else {
        this.dialogCheckActivemonth.push(typeitem)
      }
    },
    clickDialogTime1 (item) {
      const index = this.dialogCheckActivemonth.findIndex(item1 => item1 === item.value)
      if (index > -1) {
        this.dialogCheckActivemonth.splice(index, 1)
      } else {
        this.dialogCheckActivemonth.push(item.value)
      }
    },
    async changeTab1 (item) {
      this.level1 = item.value
      this.timeList = []
      this.dialogCheckActivemonth = []
      await this.getTimeList()
    },
    // 查看图片
    async show_before_img (item) {
      this.imgBig = item.courseImgUrl
      // [6,32, 39, 44, 1, 38] 可以组合 当前国内 除了这两种都可以组合
      if (item.typeId !== 4 && item.typeId !== 56) {
        this.currentItem = item
        this.combinationShow = true
      } else {
        // 检查缓存
        if (this.imageCache.has(this.imgBig)) {
          this.imgBigShow = true
          return
        }
        // 显示加载中
        const loadingToast = this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
          duration: 0
        })
        try {
          await this.preloadImage(this.imgBig)
          loadingToast.clear()
          this.imgBigShow = true
        } catch (error) {
          loadingToast.clear()
          this.$toast('图片加载失败')
        }
      }
    },
    preloadImage (url) {
      return new Promise((resolve, reject) => {
        if (this.imageCache.has(url)) {
          resolve()
          return
        }

        const img = new Image()
        img.onload = () => {
          this.imageCache.set(url, true)
          resolve()
        }
        img.onerror = reject
        img.src = url
      })
    },
    closeImgBig () {
      this.imgBig = ''
      this.imgBigShow = false
      this.zuImg = ''
      this.imgBigShow1 = false
      this.checkedCombination = null
    },
    async setWXShareInfo () {
      const currentRouter = this.$router.currentRoute.fullPath
      const basehref = `https://domestic.gecacademy.cn${currentRouter}`
      const shareTitle = '全球华人导师科研'
      const shareDesc = 'Future Scholar\r\n学思砺新, 笃行致远'
      const shareImgUrl = 'https://gecacademy.oss-cn-beijing.aliyuncs.com/sou/%E9%9D%92%E6%A4%92-H5%E5%9B%BE%E6%A0%872.jpg'
      const shareInfo = {
        title: shareTitle,
        desc: shareDesc,
        link: basehref,
        imgUrl: shareImgUrl,
        success () {},
        cancel () {}
      }
      const test = Math.random()
      const timestamp = parseInt(new Date() / 1000)
      const params = {
        timestamp,
        noncestr: String(test),
        url: basehref,
        appName: 'domestic'
      }
      const result = await axios.post('https://gec-api.gecacademy.cn/souapi/wechat/sellTool/getSign', params)
      // console.log(result, 'ok--s')
      const signature = result.data.data.signature
      const wx = this.$wx
      await wx.configAsync({
        debug: false,
        appId: 'wxf88eda53c74e883f',
        timestamp,
        nonceStr: String(test),
        signature,
        jsApiList: [
          'onMenuShareTimeline',
          'onMenuShareAppMessage',
          'chooseImage',
          'previewImage',
          'uploadImage',
          'chooseWXPay'
        ]
      })
      wx.onMenuShareTimeline(shareInfo)
      wx.onMenuShareAppMessage(shareInfo)
      wx.updateAppMessageShareData(shareInfo)
      wx.updateTimelineShareData(shareInfo)
    },
    async changeCombination () {
      setTimeout(async () => {
        if (!this.checkedCombination) return
        if (this.checkedCombination * 1 === 1) {
        // 检查缓存
          if (this.imageCache.has(this.imgBig)) {
            this.imgBigShow = true
            this.combinationShow = false
            return
          } else {
          // 显示加载中
            const loadingToast = this.$toast.loading({
              message: '加载中...',
              forbidClick: true,
              duration: 0
            })
            try {
              await this.preloadImage(this.imgBig)
              loadingToast.clear()
              this.imgBigShow = true
            } catch (error) {
              loadingToast.clear()
              this.$toast('图片加载失败')
            }
          }
        } else {
          this.addCombinationShow = true
        }
        this.combinationShow = false
      }, 100)
    },
    clickCombinationShow () {
      this.combinationShow = false
      this.checkedCombination = null
    },
    clickCombinationShow1 () {
      this.addCombinationShow = false
      this.checkedCombination = null
      this.combination.date = null
      this.combination.type = null
    },
    getdate () {
      this.showDate = true
    },
    async onConfirm (e) {
      const formatDate = (date) => `${new Date(date).getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`
      this.combination.date = formatDate(e[0]) + '-' + formatDate(e[1])
      this.combination.dateList = [new Date(e[0]).toJSON(), new Date(e[1]).toJSON()]
      this.showDate = false
      if (this.currentItem.typeId === 45 && !this.combination.type) {
        // Dialog({ message: '请选择项目类型' })
        return
      }
      const obj = {
        courseType: null,
        schoolBegins: this.combination.dateList,
        name: this.combination.name
      }
      if (this.currentItem.typeId !== 45) {
        obj.courseType = 45
      } else {
        obj.courseType = this.combination.typeId
      }
      const loading = Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      const { data } = await getCombinationCourseList(obj)
      if (data) {
        this.courseList = data
      }
      loading.clear()
    },
    async onConfirm1 (e) {
      const loading = Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      this.showTypePicker = false
      this.combination.type = e.name
      this.combination.typeId = e.id
      const obj = {
        courseType: this.combination.typeId,
        schoolBegins: this.combination.dateList,
        name: this.combination.name
      }
      const { data } = await getCombinationCourseList(obj)
      if (data) {
        this.courseList = data
      }
      loading.clear()
    },
    async onConfirm2 (e) {
      this.showCourseListPicker = false
      this.combination.courseId = e.id
      this.combination.courseName = e.name
    },
    checkColor (type) {
      if (type === 1) {
        if (this.combinationDetail.directionId * 1 === 7) {
          return 'linear-gradient(to right, #D99F43, rgba(255,255,255,0))'
        } else if (this.combinationDetail.directionId * 1 === 11) {
          return 'linear-gradient(to right, #6AB19D, rgba(255,255,255,0))'
        } else if (this.combinationDetail.directionId * 1 === 17) {
          return 'linear-gradient(to right, #9883AC, rgba(255,255,255,0))'
        } else if (this.combinationDetail.directionId * 1 === 33) {
          return 'linear-gradient(to right, #4586BC, rgba(255,255,255,0))'
        }
      } else {
        if (this.combinationDetail.directionId * 1 === 7) {
          return 'linear-gradient(to top, #D99F43, rgba(255,255,255,0))'
        } else if (this.combinationDetail.directionId * 1 === 11) {
          return 'linear-gradient(to top, #6AB19D, rgba(255,255,255,0))'
        } else if (this.combinationDetail.directionId * 1 === 17) {
          return 'linear-gradient(to top, #9883AC, rgba(255,255,255,0))'
        } else if (this.combinationDetail.directionId * 1 === 33) {
          return 'linear-gradient(to top, #4586BC, rgba(255,255,255,0))'
        }
      }
    },
    checkColor1 () {
      if (this.combinationDetail.directionId * 1 === 7) {
        return '#D99F43'
      } else if (this.combinationDetail.directionId * 1 === 11) {
        return '#6AB19D'
      } else if (this.combinationDetail.directionId * 1 === 17) {
        return '#9883AC'
      } else if (this.combinationDetail.directionId * 1 === 33) {
        return '#4586BC'
      }
    },
    clickCouselist () {
      if (this.currentItem.typeId === 45 && !this.combination.type) {
        Dialog({ message: '请选择项目类型' })
        return
      }
      this.showCourseListPicker = true
    },
    async changeName () {
      if (!this.combination.name) return
      if (this.currentItem.typeId === 45 && !this.combination.type) {
        Dialog({ message: '请选择项目类型' })
        return
      }
      const loading = Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      const obj = {
        courseType: this.currentItem.typeId !== 45 ? 45 : this.combination.typeId,
        schoolBegins: this.combination.dateList,
        name: this.combination.name
      }
      const { data } = await getCombinationCourseList(obj)
      if (data) {
        this.courseList = data
      }
      this.combination.courseName = null
      this.combination.courseId = null
      loading.clear()
    },
    async getQrCode (item) {
      document.getElementById('qr-code').innerHTML = ''
      const qr = new QRCode('qr-code', {
        width: 90, // 二维码宽度，单位像素
        height: 90, // 二维码高度，单位像素
        text: `https://sou-m.gecacademy.cn/share?id=${item.course1.id}&from=qrcode` // 生成二维码的链接
      })
      document.getElementById('qr-code1').innerHTML = ''
      const qr1 = new QRCode('qr-code1', {
        width: 90, // 二维码宽度，单位像素
        height: 90, // 二维码高度，单位像素
        text: `https://sou-m.gecacademy.cn/share?id=${item.course2.id}&from=qrcode` // 生成二维码的链接
      })
      await this.saveImage('html2canvas', '组合海报')
      console.log(qr, qr1)
    },
    // 图片格式转换方法
    dataURLToBlob (dataurl) {
      const arr = dataurl.split(',')
      const mime = arr[0].match(/:(.*?);/)[1]
      const bstr = atob(arr[1])
      let n = bstr.length
      const u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },
    // 点击方法
    saveImage (divText, imgText) {
      const loading = Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      const canvasID = this.$refs[divText]
      html2canvas(canvasID, {
        useCORS: true, // 允许加载跨域的图片
        allowTaint: true, // 开启跨域
        logging: false // 关闭日志，提高性能
      }).then(canvas => {
        const imageBase64 = canvas.toDataURL('image/png', 0.8)
        this.imgBigShow1 = true
        this.zuImg = imageBase64
        this.imgBigShow = false
        this.currentItem = null
        this.combination = {
          name: '',
          type: '',
          typeId: '',
          courseTypeId: '',
          courseName: '',
          courseId: ''
        }
        this.addCombinationShow = false
        this.checkedCombination = null
        loading.clear()
      }).catch(function (error) {
        Toast.fail(error.message)
        loading.clear()
      })
    },
    async  sureGetList () {
      // 企业远程实训
      if (!this.combination.courseId) {
        Dialog({ message: '请选择项目' })
        return
      }
      // 其他科研xiangm
      this.zuloading = Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      // 45 企业导师远程实训，
      try {
        const { data, error } = await getCombinationPoster(
          {
            courseId1: this.currentItem.typeId === 45 ? this.combination.courseId : this.currentItem.id,
            courseId2: this.currentItem.typeId === 45 ? this.currentItem.id : this.combination.courseId
          }
        )
        if (data) {
          this.combinationDetail = data
          this.checkImage()
          this.$nextTick(() => {
            this.getQrCode(this.combinationDetail)
          })
        }
        if (error.returnMessage) {
          Toast.fail(error.returnMessage)
        }
      } catch (error) {
        console.log(error, 'sdksdk')
      }
    },
    checkImage () {
      const result = this.combinationDetail.imgUrl ? `url('${this.combinationDetail.imgUrl}')` : ''
      return result
    },
    getShow (type) {
      if (type === 1) {
        // 四大类是后台返回专业方向
        return (this.pageType !== 9999 && this.pageType !== 5 && this.pageType !== 6 && this.pageType !== 7 && this.pageType !== 44 && this.pageType !== 8 && this.pageType !== 9)
      } else {
        // 其他项目类型写专业方向
        return !(this.pageType !== 9999 && this.pageType !== 5 && this.pageType !== 6 && this.pageType !== 7 && this.pageType !== 44 && this.pageType !== 8 && this.pageType !== 9)
      }
    }
  }
}
